/* OrthoticShop QA integration: suppress only Google's visible merchant badge.
   Observe the document root because third-party widgets can be outside body. */
(() => {
  const badgeIds = ['google-merchantwidget-iframe-wrapper', 'google-merchantwidget-jframe-wrapper'];
  const originals = new WeakMap();
  let scheduled = false;
  function visible(element) {
    for (let parent = element; parent; parent = parent.parentElement) {
      if (parent.hidden || parent.getAttribute('aria-hidden') === 'true') return false;
      const style = getComputedStyle(parent);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    const box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < window.innerHeight;
  }
  function sync() {
    scheduled = false;
    const hide = [...document.querySelectorAll('.swatchbro-sticky, .bis-sticky, .sticky-atc-bar, [data-helpbro-host] > section')].some(visible);
    for (const id of badgeIds) {
      const badge = document.getElementById(id);
      if (!badge) continue;
      if (hide) {
        if (!originals.has(badge)) originals.set(badge, {
          value: badge.style.getPropertyValue('display'),
          priority: badge.style.getPropertyPriority('display')
        });
        if (badge.style.getPropertyValue('display') !== 'none' || badge.style.getPropertyPriority('display') !== 'important') {
          badge.style.setProperty('display', 'none', 'important');
        }
      } else if (originals.has(badge)) {
        const original = originals.get(badge);
        originals.delete(badge);
        // Do not overwrite a subsequent visibility decision by another widget.
        if (badge.style.getPropertyValue('display') === 'none' && badge.style.getPropertyPriority('display') === 'important') {
          if (original.value) badge.style.setProperty('display', original.value, original.priority);
          else badge.style.removeProperty('display');
        }
      }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['hidden', 'aria-hidden', 'style', 'class']
  });
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  schedule();
})();
